export const USER_TYPE = {
  ADMIN: 1,
  USER: 2,
  SUB_USER: 3,
};

export const USER_STATUS = {
  ACTIVE: 1,
  BLOCKED: 2,
  ARCHIVED: 3,
  PENDING_APPROVAL: 4,
};

/** Legacy aliases kept for existing numeric values. */
export const USER_STATUS_LEGACY = {
  DEACTIVE: USER_STATUS.BLOCKED,
  DELETED: USER_STATUS.ARCHIVED,
  WARMING: USER_STATUS.PENDING_APPROVAL,
};

export const USER_TYPE_LABELS = {
  [USER_TYPE.ADMIN]: 'Admin',
  [USER_TYPE.USER]: 'User',
  [USER_TYPE.SUB_USER]: 'Sub-user',
};

export const USER_STATUS_LABELS = {
  [USER_STATUS.ACTIVE]: 'Active',
  [USER_STATUS.BLOCKED]: 'Blocked',
  [USER_STATUS.ARCHIVED]: 'Archived',
  [USER_STATUS.PENDING_APPROVAL]: 'Unapproved',
};

export const NOT_SET_LABEL = 'Not set';
export const PLACEHOLDER_DASH = '—';
